export enum ACTION_TYPE {
    ADD_ACTION = "ADD_ACTION",
    UPDATE_ACTION = "UPDATE_ACTION"
}

export enum USER_TYPE {
    ADMIN = "Admin",
    USER = "User"
}

export enum REPORT_NAME {
    DEPARTMENT_MASTER = "Department Master",
    PROJECT_MASTER = "Project Master",
    PROJECT_USER_MASTER = "Project User Master",
    PROJECT_TYPE_MASTER = "Project Type Master",
    PHASE_MASTER = "Phase Master",
    PROJECT_PHASE_ACTIVITY = "Project Phase Activity",
    KRA_MASTER = "Key Result Area Master",
    TIME_SHEET = "Time Sheet",
    ORGANIZATION_MASTER = "Organization Master",
    USER_MASTER = "User Master",
    USER_GROUP = "User Group",
    USER_ROLE = "Subscriber",

    // Data Source Management report names
    VALUE_CHAIN_CATEGORY = 'Value Chain Category',
    VALUE_CHAIN = 'Value Chain',
    DATA_PIPELINE_CATEGORY = 'Data Pipeline Category',
    DATA_PIPELINE = 'Data Pipeline',
    TERM_SET = 'Term Set',
    TERM = 'Term',
    DATA_RECORD = 'Data Record',
    VALUE_CHAIN_PARAGRAPH_EXTRACT = 'Value Chain Paragraph Extract',
    AGENT_MASTER = "Agent Master",
    // Common
    COUNTRY = 'Country',
    STATE = 'State',

    PDF_LIBRARY = "AI Dharma Library",

    LIBRARY_CATEGORY = "Library Category",
    LIBRARY = "Private Library",

}

export enum REPORT_PATH {
    DEPARTMENT_MASTER = "departmentMaster",
    PROJECT_MASTER = "projectMaster",
    PROJECT_USER_MASTER = "projectUserMaster",
    PROJECT_TYPE_MASTER = "projectTypeMaster",
    PHASE_MASTER = "phaseMaster",
    PROJECT_PHASE_ACTIVITY = "projectPhaseActivity",
    KRA_MASTER = "kraMaster",
    TIME_SHEET = "timeSheet",
    ORGANIZATION_MASTER = "organizationMaster",

    //User Master report 
    USER_MASTER = "userMaster",
    USER_GROUP = "userGroup",
    USER_ROLE = "userRole",

    PDF_LIBRARY = "pdfLibrary",

    // Data Source Management report
    VALUE_CHAIN_CATEGORY = 'value-chain-category',
    VALUE_CHAIN = 'value-chain',
    DATA_PIPELINE_CATEGORY = 'data-pipeline-category',
    DATA_PIPELINE = 'data-pipeline',
    TERM_SET = 'term-set',
    TERM = 'term',
    DATA_RECORD = 'data-record',
    VALUE_CHAIN_PARAGRAPH_EXTRACT = 'pragraph-extract',
    AGENT_MASTER = "agent-master",
    
    LIBRARY_CATEGORY = "library-category",
    LIBRARY = "private-library",

    // Common
    COUNTRY = 'country',
    STATE = 'state',
}

export enum PAGE_TITLE {
    FORGOT_PASSWORD = "Forgot Password",
    RESET_PASSWORD = "Reset Password",
}